/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */
import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const ArrowDownUp24 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#0E0E0E"
      d="M6 4a1 1 0 1 1 2 0v13.586l2.293-2.293a1 1 0 1 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4-.069-.076a1 1 0 0 1 1.407-1.406l.076.068L6 17.586V4Zm10 16V6.414l-2.293 2.293a1 1 0 1 1-1.414-1.414l4-4 .073-.066a1 1 0 0 1 1.34.066l4 4 .07.076a1 1 0 0 1-1.407 1.406l-.076-.068L18 6.414V20a1 1 0 1 1-2 0Z"
    />
  </svg>
);

const SIZE_MAP = {
  sm: ArrowDownUp24,
  md: ArrowDownUp24,
  lg: ArrowDownUp24,
  xl: ArrowDownUp24,
  xxl: ArrowDownUp24,
  xxxl: ArrowDownUp24,
};

export const ArrowDownUpIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'arrow-down-up-icon'}
      icon={SIZE_MAP[size]}
      {...props}
      size={size}
    />
  );
};
